import { api } from '../config/api'
import store from '../config/store'
import { generateApiUrl, generateGetApiUrl } from '../utils/urlHelpers'
import { Methods, makeRequest } from './Request'

export const getCompanies = (params) => {
  const url = generateGetApiUrl(api.routes.companies.list, params)
  return makeRequest(url, Methods.GET)
}

export const getUserCompanies = (userId) => {
  const url = generateApiUrl(api.routes.companies.users, { userId })
  return makeRequest(url, Methods.GET)
}

export const getCompany = (id) => {
  const url = generateApiUrl(api.routes.companies.get, { id })
  return makeRequest(url, Methods.GET)
}

export const updateCompany = (values, method = Methods.PATCH, forceId) => {
  const { currentCompany } = store.getState().auth
  const url = generateApiUrl(api.routes.companies.get, {
    id: forceId || currentCompany?.id,
  })
  return makeRequest(url, method, values, {
    'Content-Type':
      method != Methods.PATCH
        ? 'multipart/form-data'
        : 'application/x-www-form-urlencoded',
  })
}

export const createCompany = (values) => {
  const url = generateApiUrl(api.routes.companies.update)
  return makeRequest(url, Methods.POST, values)
}

export const getScreensCompany = (companyId) => {
  const url = generateApiUrl(api.routes.companies.list_screens, {
    id: companyId,
  })
  return makeRequest(url)
}

export const checkAccess = (companyId) => {
  const url = generateApiUrl(api.routes.companies.checkAccess, {
    id: companyId,
  })
  return makeRequest(url)
}

export const checkUpdatePermission = (id) => {
  const url = generateApiUrl(api.routes.companies.checkUpdatePermission, { id })
  return makeRequest(url)
}
